
export enum RegistrationResponse { 
    registered = 101,
    emailAlreadyRegistered = 102,
    missingFormFields = 103,
    badData = 104,
    invalidJoiningCode = 105
}

